module.exports = __webpack_public_path__ + "static/media/referralImg.94a33225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/referralImg.png
// module id = 1100
// module chunks = 1